module.exports = __webpack_public_path__ + "static/media/feature-workflows.19a7c534.svg";